import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { widgetOrderService } from '../services/widgetOrderService';
import type { OrderItem } from '../context/MorningDashboardContextProps';

export const WIDGET_ORDER_QUERY_KEY = ['morning-dashboard', 'layout'] as const;

export const useWidgetOrder = () => {
    return useQuery<OrderItem[]>({
        queryKey: WIDGET_ORDER_QUERY_KEY,
        queryFn: widgetOrderService.getLayout,
    });
};

export const useSaveWidgetOrder = (onSuccess?: () => void) => {
    const queryClient = useQueryClient();
    return useMutation<void, Error, OrderItem[]>({
        mutationFn: widgetOrderService.updateLayout,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WIDGET_ORDER_QUERY_KEY });
            onSuccess?.();
        },
    });
};
